import { CKContainerProps } from 'clearkit';

import { useEntitlements } from '../useEntitlements';

export const WhenUsagePreview = ({ children }: CKContainerProps) => {
  const { hasAccessUsagePreview } = useEntitlements();

  return hasAccessUsagePreview ? <>{children}</> : null;
};
